import React from 'react';
import cx from 'clsx';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Theme } from 'types';

interface ModalHeaderProps {
  title?: string;
  className?: string;
  children?: React.ReactNode;
}

export const ModalHeader = ({ title, className, children }: ModalHeaderProps) => {
  const classes = useStyles();

  const content = title ? (
    <Typography variant="h2" component="h1">
      {title}
    </Typography>
  ) : (
    children
  );

  return <header className={cx(classes.root, className)}>{content}</header>;
};

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    justifyContent: 'flex-start',
    alignItems: 'center',
    display: 'flex',
    minHeight: 100,
    paddingLeft: theme.spacing(4),
    borderBottom: `1px solid ${theme.palette.divider}`
  }
}));

export default ModalHeader;
